import { useSelector } from "react-redux";
import { getFormAuthority } from "../auth/authHelper";
import { useState } from "react";

const useNextAndPreviousAuthority = ({
  sectionKey = null,
  section = null,
  currentTab = null,
  minTab = 1,
  maxTab = 1,
  module = null,
  authenticated = false,
}) => {
  const [formTabMap, setFormTabMap] = useState([]);
  const auth = useSelector((state) => state.user.permissions[module]);
  if (!authenticated) {
    return {
      prev: () => (currentTab > minTab ? currentTab - 1 : currentTab),
      next: () => (currentTab < maxTab ? currentTab + 1 : currentTab),
      isAuthorized: (tab) => true,
    };
  }

  const getTempFormTabs = () => {
    let tempFormTab = [];
    for (let { form, tab } of Object.values(section)) {
      const { view } = getFormAuthority(auth, form, false);

      if (view && tab !== 0) {
        tempFormTab.push({
          form: form,
          tab: tab,
        });
      }
    }
    return tempFormTab.sort((a, b) => a.tab - b.tab);
  };

  if (sectionKey == null || section === null || currentTab === null) {
    return {
      prev: () => null,
      next: () => null,
      isAuthorized: (tab) => false,
    };
  }

  if (formTabMap[sectionKey]) {
    const currentTabIndex = formTabMap[sectionKey].findIndex(
      (formTab) => formTab.tab === currentTab,
    );
    return {
      prev: () => {
        return currentTabIndex === 0
          ? currentTab
          : formTabMap[sectionKey][currentTabIndex - 1]?.tab;
      },
      next: () =>
        currentTabIndex === maxTab - 1
          ? currentTab
          : formTabMap[sectionKey][currentTabIndex + 1]?.tab,
      firstViableTab: () => formTabMap[sectionKey][0],
      isAuthorized: (tab) => {
        const formTab = formTabMap[sectionKey].find(
          (formTab) => formTab.tab === tab,
        );
        return !!formTab;
      },
    };
  }

  const sortedTempFormTabs = getTempFormTabs();
  setFormTabMap((prevState) => ({
    ...prevState,
    [sectionKey]: sortedTempFormTabs,
  }));
  const currentTempTabIndex = sortedTempFormTabs.findIndex(
    (formTab) => formTab.tab === currentTab,
  );
  return {
    prev: () =>
      currentTempTabIndex === 0
        ? currentTab
        : sortedTempFormTabs[currentTempTabIndex - 1]?.tab,
    next: () =>
      currentTempTabIndex === maxTab - 1
        ? currentTab
        : sortedTempFormTabs[currentTempTabIndex + 1]?.tab,
    isAuthorized: (tab) => {
      const formTab = sortedTempFormTabs.find((formTab) => formTab.tab === tab);
      return !!formTab;
    },
  };
};

export default useNextAndPreviousAuthority;
